import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useEventsService } from '../../../../apis/events/useEventsService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TEventsApiResponse } from '../../../../apis/events/events.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getEventsListKey = 'get-events-list';

export const useEventsListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TEventsApiResponse, TQueryError>
): UseQueryResult<TEventsApiResponse, TQueryError> => {
  const { getEventsList } = useEventsService();

  return useQuery<TEventsApiResponse, TQueryError>({
    queryKey: [getEventsListKey, params],
    queryFn: () => getEventsList(params),
    enabled: true,
    ...options,
  });
};
